export default "__VITE_ASSET__B66JI5Ch__"